import React from "react"
import { useForm } from 'react-hook-form';
import './DaySheet.css';

import {useState, useEffect} from 'react';
import api from "../../api/axiosConfig";
import { useParams } from "react-router-dom";

const DaySheet = ({selectedDate, employeeEmail, setEmail, month, year, setEmployeeDetails, previewStatus, setPreviewStatus, generatedSheets, setGeneratedSheets}) => {
  useEffect(() => {
    setEmail(null);
  }, []);
  var defaultHours = 8;
  var disableHours = 16;

  const { register, handleSubmit, setValue, reset} = useForm();
  const { register: register2, handleSubmit: handleSubmit2, getValues} = useForm();

  const onSubmit = (data) => {  
    try{
      const response = api.post('/sheets/save/'+ employeeEmail + "/" + month + "/" + year, data);
      console.log(data)
    }catch(err){
      console.error(err)
    }
  };

  useEffect(() => {
    reset({ date: selectedDate.toDateString() });
  }, [selectedDate]); 

  useEffect(() => {
    getEmpDtls();
  },[employeeEmail])

  const getEmpDtls = async() =>{
    try{      
      const response = await api.get('/employee/'+ employeeEmail)
      .then((response) => response)
      .then((data) => {
        if(data.data==null){
          setPreviewStatus(false)
        }else{
        setEmployeeDetails(data)
        setPreviewStatus(true);
        }
        console.log(previewStatus)
        });
    }catch(err){
      console.log(err);
    }
  }

  const loadUser = () => {
  var formEmail = getValues("employeeEmail");
  setEmail(formEmail)
  
  }

  const handleOTChange = (e) => {
    var otHrs = e.target.valueAsNumber;
    let totalHrs = otHrs + defaultHours
    setValue("hoursWorked", totalHrs)
  }

  const handleDayTypeChange = (e) => {
    console.log(e.target.value)
    if(e.target.value == "Regular Workday"){
      disableHours = 16;
      defaultHours = 8;
      setValue("hoursWorked", 8);
      setValue("hoursOvertime", 0);
    }
    else if(e.target.value == "Absence"||e.target.value == "Sick Leave"||e.target.value == "Annual Leave"){
      disableHours = 0;
      console.log(disableHours)
      defaultHours = 0;
      setValue("hoursWorked", 0);
      setValue("hoursOvertime", 0);
    }
    else{
      disableHours = 16;
      defaultHours = 0;
      setValue("hoursWorked", 0);
      setValue("hoursOvertime", 0);
    }
  }

  useEffect(() => {
    setValue("dayType", 'Regular Workday')
    setValue("hoursWorked", 8);
    setValue("hoursOvertime", 0);
  }, [selectedDate]);
  
  return (
  <div>
    {!previewStatus &&(
      <form onSubmit={handleSubmit2(loadUser)} className="form1" key={2}>
        <div className="empDetails">
        <input type="email" className = "empEmail" placeholder="Email" name="employeeEmail"{...register2("employeeEmail", {required: true})} /> 
        <input type="submit" className="loadBtn"  value="Load Profile" />
        </div>
      </form>
    )}

  {previewStatus &&(
    <div>
    <form onSubmit={handleSubmit(onSubmit)} className="form2" key={1}>
      <div className="dayDetails">
        <label className="dayFormLabel">Selected Date</label>
        {/* when changes, back to regular workday daytpe */}
        <input type="text" className="txtBox" readOnly={true} {...register("date")}/>
        <label className="dayFormLabel">Day Type</label>
        <select className="selectBox" {...register("dayType", { required: true })} onChange={handleDayTypeChange}>          
          <option value="Regular Workday">Regular Workday</option>
          <option value="Weekend">Weekend</option>
          <option value="Public Holiday">Public Holiday</option>
          <option value="Sick Leave">Sick Leave</option>
          <option value="Annual Leave">Annual Leave</option>
          <option value="Absence">Absence</option>
        </select> 
      
      {/*day type validation*, leave = 0, weekend public holiday = all hours overtime=hoursworked*/}
        <label className="dayFormLabel">Hours Worked  </label>
        <input type="number" defaultValue = {defaultHours} readOnly={true}  name="hoursWorked" 
        {...register("hoursWorked", {required: true, pattern: /^\d|1\d|2[0-3]/i})} />
      
        <label className="dayFormLabel" >Hours Overtime</label>
        <input type="number" defaultValue = "0" name = "hoursOvertime" min={0} max = {disableHours}
        {...register("hoursOvertime", {required: true, pattern: /^\d|1\d|2[0-3]/i})} onChange={handleOTChange}  />
      
        {/* <input type="button" onClick={() => reset()} value="Clear" className="clearBtn"/> */}
        <input type="submit" value = "Save" className="submitBtn1"/>
      </div>
    </form>
    <div className="instructionsContainer">
    <p className="instructions">Please set your weekends, overtime hours, leaves, and public holidays.
        Upon PREVIEW AND SUBMIT, Regular Workdays (Mon - Fri) will be set to an 
        8-hour workday by default unless stated otherwise.</p>
    </div>
    </div>
  )}

  </div>
    
  )
};

export default DaySheet;
